<template>
    <TagStatus v-if="steps" :id="step" :label="steps[step].label" />
</template>

<script>
import TagStatus from 'vcomponents/common/TagStatus/TagStatus.vue';
const expirationDuration = 604800; // one week

export default {
    components: {
        TagStatus,
    },
    props: {
        doctype: {
            required: true,
            type: String,
        },
        step: {
            required: true,
            type: String,
        },
    },
    data() {
        return {
            steps: null,
        };
    },
    computed: {
        storageKey() {
            return `document_sale_${this.doctype}_step`;
        },
    },
    created() {
        const objet = JSON.parse(localStorage.getItem(this.storageKey));

        if (objet === null || objet.expire_at < new Date().getTime()) {
            this.fetchSteps();
        } else {
            this.steps = objet.value;
        }
    },
    methods: {
        fetchSteps() {
            window.SellsyJS.WebServiceCaller.get(
                `/rest/sales/${this.doctype}/steps`,
                {},
                (response) => {
                    this.setSteps(response);
                },
                () => {
                    Push.error(
                        this.$l10n.__(
                            'Une erreur est survenue, veuillez ré-essayer ultérieurement.',
                        ),
                    );
                },
            );
        },
        setSteps(steps) {
            const expiration = new Date().getTime() + expirationDuration;
            const object = {
                expire_at: expiration,
                value: steps,
            };
            localStorage.setItem(this.storageKey, JSON.stringify(object));
            this.steps = steps;
        },
    },
};
</script>
